import type { GetWishlistRequest } from './types';

export const WISHLIST_QUERY_KEYS = {
  default: () => ['wishlist'] as const,
  list: (props: GetWishlistRequest) => [...WISHLIST_QUERY_KEYS.default(), 'list', props] as const,
  addProductToWishlist: () => [...WISHLIST_QUERY_KEYS.default(), 'addProductToWishlist'] as const,
  removeProductFromWishlist: () => [...WISHLIST_QUERY_KEYS.default(), 'removeProductFromWishlist'] as const,
  migrateWishlist: () => [...WISHLIST_QUERY_KEYS.default(), 'migrateWishlist'] as const,
};
